// import React from 'react';
// import PromoTemplate from '../../components/PromoTemplate';
// import { campaignsConfig } from '../../config/campaignsConfig';

// function MulherPage() {
//   const config = campaignsConfig.mulher;
//   return <PromoTemplate config={config} />;
// }

// export default MulherPage;


import React, { useEffect, useState } from "react";
import PromoTemplate from "../../components/PromoTemplate";
import { db } from "../../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

function Promoblackout() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    async function load() {
      const ref = doc(db, "campaigns", "promos club");
      const snap = await getDoc(ref);
      if (snap.exists()) setConfig(snap.data());
    }

    load();
  }, []);

  if (!config) return <div>Carregando...</div>;

  return <PromoTemplate config={config} />;
}

export default Promoblackout;
